export const COLOUR_FG_PRIMARY = "#583281";
export const COLOUR_FG_SECONDARY = "#363732";
export const COLOUR_FG_TERTIARY = "#FF3C38";
export const COLOUR_BG_PRIMARY = "#F4D35E";
export const COLOUR_BG_SECONDARY = "#9FC2CC";